import { render, staticRenderFns } from "./topicList.vue?vue&type=template&id=ed69afca&scoped=true&"
import script from "./topicList.vue?vue&type=script&lang=js&"
export * from "./topicList.vue?vue&type=script&lang=js&"
import style0 from "./topicList.vue?vue&type=style&index=0&id=ed69afca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed69afca",
  null
  
)

export default component.exports